import React from 'react';
import { motion } from 'framer-motion';
import { painPoints } from '../data/painPoints';
export function PainPoints() {
  return <section aria-label="Est-ce que cela vous ressemble" className="border-y border-grape/10 bg-white/70" data-id="element-111" data-mp="2lmsqcmz6p8ku">
      <div className="mx-auto max-w-4xl px-5 pb-12 pt-10" style={{
      paddingBottom: '8px',
      paddingTop: "11px"
    }} data-id="element-112" data-mp="26y60hrbxkyfd">
        <h2 className="text-center font-display text-[25px] font-black text-plum sm:text-4xl" data-id="element-113" data-mp="2bvfwxqxqmacp">
          👇 Est-ce que cela vous ressemble ?
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-center text-base leading-relaxed text-plum/70" data-id="element-114" data-mp="220e8kxbadcb6">
          Vous connaissez votre travail. Vous connaissez les situations auxquelles vous êtes confronté.
          Mais lorsqu’arrive le moment de rédiger, structurer, synthétiser et transmettre les informations,
          le temps commence à s’accumuler.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-center text-lg font-bold text-grape" data-id="element-115" data-mp="3ncnze6otpge8">
          Ce n’est pas un manque de compétence. C’est un manque de <span className="text-blush" data-id="element-116" data-mp="1yzdnan104dn2">structure</span>.
        </p>

        <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-117" data-mp="1u23qgmba8zp7">
          {painPoints.map((p, i) => <motion.div key={p.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 rounded-xl border border-grape/15 bg-cream p-5" style={{
          paddingTop: "10px",
          paddingBottom: "10px"
        }} data-id="element-118" data-mp="27sz040tlvktu" data-mpi={i}>
              <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-lilac-soft text-sm" aria-hidden="true" data-id="element-119" data-mp="1p3k6grg91xzh">
                {p.emoji}
              </span>
              <div data-id="element-120" data-mp="30gmjxdn1y7ff">
                <h3 className="text-sm font-bold text-plum" data-id="element-121" data-mp="30g301rdud8yr">{p.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-plum/65" data-id="element-122" data-mp="2vjckr69v2hee">{p.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-123" data-mp="1t79col36jmu4">
          <p className="font-display text-2xl font-bold text-plum sm:text-3xl" data-id="element-124" data-mp="1y3qa65w9rdjv">
            ✨ Si vous vous reconnaissez… SIGMA SMART™ a été conçu pour vous.
          </p>
        </div>
      </div>
    </section>;
}